import EnhancedPrompt from './EnhancedPrompt'

export default EnhancedPrompt
